module.exports = __webpack_public_path__ + "img/la_24.4133b838.png";